import { formatVersion } from '@mysaiva/core/utils'

/**
 * Version label for the shell app footer. Follows the unified version system
 * (`.github/VERSION_GUIDE.md`): `<MODULE> <tag>` in production and
 * `<MODULE> · <hash>` everywhere else. `VITE_GIT_TAG`/`VITE_GIT_HASH` are
 * injected by CircleCI.
 */
export function getAppVersion(moduleName = 'SAIVA'): string {
  return formatVersion(moduleName, import.meta.env.VITE_GIT_TAG, import.meta.env.VITE_GIT_HASH)
}
